'use strict';

angular.module('shiftTraderApp')
  .directive('saProfilePicture', function ($location, ServerUrls, Session) {
    var defaultImgUrlBase = 'https://s3.amazonaws.com/shift_assets/static_assets/userprofile/';
    var defaultImgFileName = '/missing.jpg';

    return {
      templateUrl:'views/directives/saProfilePicture.html',
      restrict: 'A',
      scope: {
        user:'=saProfilePicture',
        size:'@',
        watchUser:'@',
        link:'@'
      },
      replace: true,
      link: function(scope) {
        var setClassesForSize = function(size) {
          if (scope.size === 'profile') {
            scope.theRightImgClass = 'user_profile_img';
            scope.outerProfilePictureClass = 'profile_picture_128x';
            scope.theRightNoImgClass = 'place_initials_128x';
          } else if (scope.size === 'thumb') {
            scope.theRightImgClass = 'user_thumb_img';
            scope.outerProfilePictureClass = 'profile_picture_64x';
            scope.theRightNoImgClass = 'place_initials_64x';
          } else if (scope.size === 'tiny') {
            scope.theRightImgClass = 'user_tiny_img';
            scope.outerProfilePictureClass = 'profile_picture_32x';
            scope.theRightNoImgClass = 'place_initials_32x';
          } else if (scope.size === 'super_tiny') {
            scope.theRightImgClass = 'user_super_tiny_img';
            scope.theRightNoImgClass = 'place_initials_24x';
            scope.imgUrl = scope.user.avatar_urls.tiny;
            scope.outerProfilePictureClass = 'profile_picture_24x';
          } else if (scope.size === 'medium') {
            scope.theRightImgClass = 'user_medium_img';
            scope.outerProfilePictureClass = 'profile_picture_300x';
            scope.theRightNoImgClass = 'place_initials_300x';
          } else {
            console.error('NOT A VALID PROFILE PICTURE SIZE!!!');
          }
        };

        var initialize = function() {
          if (scope.user && scope.user.first_name && scope.user.last_name) {
            scope.userInitials = scope.user.first_name[0] + scope.user.last_name[0];
          } else {
            scope.userInitials = '';
          }

          if (scope.user && scope.user.avatar_urls) {
              scope.imgUrl = scope.user.avatar_urls[scope.size];
          } else if (scope.user) {
            var token = Session.getAccessToken();
            scope.imgUrl = ServerUrls.current.railsApi + 'users/' + scope.user.id + '/picture/' + scope.size + '?access_token=' + token;
          }

          setClassesForSize(scope.size);

        };

        if (!_.isUndefined(scope.user)) {
          initialize();
        } else {
          scope.userInitials = '';
          scope.imgUrl = defaultImgUrlBase + scope.size + defaultImgFileName;
          setClassesForSize(scope.size);
        }



        if (scope.watchUser === 'true') {
          scope.$watch('user.id', function () {
            initialize();
          });
        }

        scope.$watch('user.avatar_urls.tiny', function() {
          initialize();
        });

        scope.goToProfile = function() {
          if (scope.link !== 'false') {
            $location.path('/profile/' + scope.user.id);
          }
        };
      }
    };
  });
